import * as React from "react";
import * as classNames from "classnames";

export interface TextProps {}

class Text extends React.PureComponent<any, any> {
  render() {
    return (
      <input
        type={this.props.type || "text"}
        className={this.props.className}
        name={this.props.name}
        id={this.props.id}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        onFocus={this.props.onFocus}
        onKeyPress={this.props.onKeyPress}
        placeholder={this.props.placeholder}
        value={this.props.value}
        disabled={this.props.disabled}
        maxLength={this.props.maxLength}
        autoComplete={this.props.autoComplete}
      />
    );
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/Controls/Text.tsx